module.exports = __webpack_public_path__ + "img/meal-management-kr.f181ac59.png";